export default {
  newDesign: true,
  title: "Çocuklar ve Gençler İçin Ücretsiz Tanı Dersi | Kodland",
  downtimeUrl: "https://www.kodland.org/tr",
  parameters: {
    landing_id: "TrSoftSc1",
    segment: 46,
    date_start: 0,
    date_end: 6
  },
  startPage: {
    title:
      "Çocuklar ve Gençler İçin Ücretsiz Tanı Dersi",
    subtitle:
      "Çocuğunuzun güçlü yönlerini ve gelişim alanlarını belirlemeye yardımcı olacağız.",
    image: {
      url: "/welcome/soft_skills_desktop.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/soft_skills_mob.png",
      style: {
        width: "100%",
      },
    },
    button: " Ücretsiz almak için tıklayın ",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz!",
    subtitle:
      "Maalesef, telefonlar derslerimizi kullanmak için uygun değildir. Bir sonraki derslerimizde sizi görmekten mutluluk duyacağız!",
  },
  quizRotateBySteps: {
    1: {
      question: "Çocuğunuz en sık hangi zorluklarla karşılaşıyor?",
      answers: [
        "🛏️Tembellik ve erteleme",
        "📱 Telefonla çok vakit geçiriyor",
        "😠 Agresif ve kaba davranıyor",
        "😢 Kendine güvensiz ve endişeli",
        "😳 Akranlarıyla iletişim zorluğu",
        "❗ Düşünmeden risk alıyor"
      ],
    },
    2: {
      question: "Çocuğunuzun davranışında neyi geliştirmek istersiniz? Çocuğunuzun…",
      answers: [
        "🚀 Kendine daha çok güvenmesini",
        "👑 Liderlik ve sorumluluk almayı",
        "💪 Eylemlerin sonuçlarını anlamasını",
        "⏱️ Düzenli ve zamanında çalışmasını",
        "🙂 Duygularını kontrol etmesini",
        "📈 Verimli aktivitelere yönelmesini"
      ],
    },
    3: {
      question: "Deneme dersinden ne bekliyorsunuz?",
      answers: [
        "🗓️ Zorluklar için tavsiye ve plan almak",
        "🧑‍💼 Faydalı beceriler geliştirme yollarını",
        "🧑‍💻 Güçlü yönleri ve gelişim alanlarını",
        "🏆 Liderlik geliştirme aktiviteleri",
        "🙌 Diğer",
      ],
    },
    4: {
      question:
        "Çocuğunuzun çalışabileceği bir masaüstü, dizüstü bilgisayarınız veya tabletiniz var mı?",
      answers: [
        "💻 Evet",
        {
          answer: "☹️ Hayir",
          stopAnswer: true,
        },
      ],
    },
    5: {
      title: "Çocuğunuz kaç yaşında?",
      subtitle: "Çocuğunuzun yaşına göre en eğlenceli kursu seçeceğiz.",
      type: "age",
      button: "",
    },
    6: {
      title: "Tebrikler! 🎉",
      typeInfo: "congrats",
      subtitle:
        "Kaydı tamamlamak için '📆 Rezervasyon yapın' seçeneğine tıklayın.",
      button: "📆 Rezervasyon yapın",
    },
    7: {
      title: "Ücretsiz ders rezervasyonu yapın",
      type: "one-page-contacts",
      subtitle: "",
      button: "Neredeyse bitti 🔥",
    },
    8: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    9: {
      title:
        "Kaydı tamamlamak için bu bilgileri inceleyin ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Derse katılmak için lütfen masaüstü veya dizüstü bilgisayar kullanın ve ders boyunca çocuğunuza eşlik etmeyi unutmayın. Deneme dersinin bireysel ve kişiye özel olduğunu hatırlatmak isteriz.",
      button: "Başka neler var?",
    },
    10: {
      title: "Deneme dersinizden önce e-posta ve WhatsApp üzerinden iletişimde kalacağız. 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Dersinizden 24 saat önce bir hatırlatma göndereceğiz ve 2 saat öncesinde katılımınızı onaylamanızı isteyeceğiz. İletişim kurmamız, dersinizin planlandığı gibi gerçekleşmesi için önemlidir.",
      button: "Başka neler var?",
    },
    11: {
      title: "Ders platformumuzda gerçekleşecek 💻",
      typeInfo: "classroom",
      subtitle:
        "WhatsApp ve e-posta yoluyla bir bağlantı ve özel bir kod alacaksınız. Sadece bağlantıya tıklayın, doğrudan derse yönlendirileceksiniz. Ekstra uygulama veya indirme gerekmiyor.",
      button: "Anladım ✅",
    }
  },
};
